import { service } from '../../../../helpers/http'

export const ActionShowTimeSheet = ({ dispatch }, payload ) => {

    return service({
        module: 'timeSheet',
        action: 'showTimeSheet',
        payload: payload
    })

}

export const ActionOnDemandTimeSheetStatus = ({ dispatch }, payload ) => {
    return service({
        module: 'timeSheet',
        action: 'onDemandTimeSheetStatus',
        payload: payload
    })
}

export const ActionOnDemandTimeSheetGenerate = ({ dispatch }, payload ) => {
    return service({
        module: 'timeSheet',
        action: 'onDemandTimeSheetGenerate',
        payload: payload
    })
}